var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcesses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 2.93194H15.125C15.7473 2.93194 16.25 3.51897 16.25 4.24557V14.7546C16.25 15.4812 15.7473 16.0682 15.125 16.0682H12.875C12.2527 16.0682 11.75 16.6552 11.75 17.3818C11.75 18.1084 12.2527 18.6955 12.875 18.6955H15.125C16.9883 18.6955 18.5 16.9303 18.5 14.7546V4.24557C18.5 2.06987 16.9883 0.304688 15.125 0.304688H12.875C12.2527 0.304688 11.75 0.891715 11.75 1.61831C11.75 2.34491 12.2527 2.93194 12.875 2.93194ZM12.5445 10.4278C12.984 9.91469 12.984 9.08136 12.5445 8.56822L8.04453 3.31371C7.60508 2.80058 6.89141 2.80058 6.45195 3.31371C6.0125 3.82685 6.0125 4.66018 6.45195 5.17332L9.03242 8.18645H1.625C1.00273 8.18645 0.5 8.77348 0.5 9.50008C0.5 10.2267 1.00273 10.8137 1.625 10.8137H9.03242L6.45195 13.8268C6.0125 14.34 6.0125 15.1733 6.45195 15.6864C6.89141 16.1996 7.60508 16.1996 8.04453 15.6864L12.5445 10.4319V10.4278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesses);
export default __webpack_public_path__ + "static/media/processes.222c40da26230d78aeb764a6857c3372.svg";
export { ForwardRef as ReactComponent };